import React, { useState } from 'react';
import { isEmpty } from 'lodash';

import { Box } from '@mui/material';
import { Table, Modal, TableFilterModel } from 'design-library';

import { IExpert } from 'common/models';

import { useExperts } from 'admin/hooks';
import { UsageTireEnum, getEnumKeys } from 'common/enums';
import { UserManagementServices } from 'admin/services';

import { UserActions } from './UserActions';
import { ExpertProfile } from './expert-profile';

export const ExpertsTable = () => {
  const [selectedExpert, setSelectedExpert] = useState<IExpert | null>(null);
  const {
    isLoadingExperts,
    expertResults,
    setPaginationModel,
    paginationModel,
    setQueryOptions,
  } = useExperts();

  const onExpertRowClick = (expert: IExpert) => {
    setSelectedExpert(expert);
  };

  const onCloseExpertProfileModal = () => {
    setSelectedExpert(null);
  };

  const getFormattedRows = (experts: Array<IExpert>) =>
    experts.map((expert) => ({
      actions: expert,
      email: expert.email,
      id: expert.id,
      name: expert.name,
      status: expert.isOnline ? 'Online' : 'Offline',
      subscription:
        getEnumKeys(UsageTireEnum)[(expert.subscription?.type || 1) - 1],
      tokens: UserManagementServices.isProExpert(expert.subscription?.type)
        ? 'Infinity'
        : expert.subscription?.totalToken,
    }));

  const onFilterChange = React.useCallback(
    (filterModel: TableFilterModel) => {
      setQueryOptions(
        filterModel.items.reduce(
          (acc, item) =>
            item.value ? { ...acc, [item.field]: item.value } : acc,
          {}
        )
      );
    },
    [setQueryOptions]
  );

  return (
    <Box>
      <Modal
        onCancel={onCloseExpertProfileModal}
        isShown={!isEmpty(selectedExpert)}
      >
        <ExpertProfile readOnly expert={selectedExpert as IExpert} />
      </Modal>
      <Table
        columns={[
          {
            field: 'name',
            headerName: 'Expert Name',
            width: 220,
          },
          {
            field: 'email',
            headerName: 'Email',
            width: 220,
          },
          {
            field: 'status',
            filterable: false,
            headerName: 'Status',
            width: 140,
          },
          {
            align: 'center',
            field: 'subscription',
            filterable: false,
            headerName: 'Subscription',
            width: 120,
          },
          {
            align: 'center',
            field: 'tokens',
            filterable: false,
            headerAlign: 'center',
            headerName: 'Tokens',
            width: 150,
          },
          {
            align: 'center',
            field: 'actions',
            filterable: false,
            // flex: 1,
            headerAlign: 'center',
            headerName: 'Actions',
            renderCell: (params) => (
              <UserActions
                userId={params.value.id}
                isUserActive={params.value.isActive}
                onClickProfileView={() => onExpertRowClick(params.value)}
                role="expert"
              />
            ),
            width: 200,
          },
        ]}
        loading={isLoadingExperts}
        paginationMode="server"
        onPaginationModelChange={setPaginationModel}
        paginationModel={paginationModel}
        pageSizeOptions={[paginationModel.pageSize]}
        rowCount={expertResults.total}
        rows={getFormattedRows(expertResults.data)}
        slots={
          {
            // noRowsOverlay: () => <BidTableEmptyState />,
          }
        }
        filterMode="server"
        onFilterModelChange={onFilterChange}
      />
    </Box>
  );
};
